import './App.css';
import Questions from './Components/Questions';
import Header from './Components/Header';

function App() {
  return (
    <div className="App">
      <Header/>
      <Questions/>
    </div>
  );
}

export default App;
